module.exports = __webpack_public_path__ + "img/promotion-2.927f403d.png";